/* eslint-disable camelcase */
import { TealiumPayload } from '../@types'

export interface ClickEventOptions {
  logged_in: boolean;
  /**
   * The text of the button or link clicked on by the user
   */
  text: string;
  /**
   * The href or action associated with an interaction.
   *
   * For buttons and links that take the user to a URL, this should be the URL (i.e., the href).
   *
   * For links or buttons that perform some action with javascript, provide a short description.
   */
  target_location?: string;
  /**
   * Dropdown button labels for clicks within the dropdown menu
   */
  heading?: string;
  /**
   * The subheading label within the dropdown menu for clicks within the dropdown menu
   */
  subheading?: string;
  /**
   * The section of the navigation where the event occurred
   *
   * general nav click,
personal nav click, logo click, gov banner click, language selection click
   */
  category: string;
}

export const sendTealiumClickEvent = async (options: ClickEventOptions): Promise<string> => {
  if (!window.utag) return ''

  const { logged_in, text, target_location = '', heading = '', subheading = '', category } = options

  const event_category = 'consistent header'
  const event_action = `${category} click`
  const event_label = text

  const payload: TealiumPayload = {
    logged_in: logged_in ? 'true' : 'false',
    event_name: 'header_click',
    event_type: 'ui interaction',
    text,
    target_location,
    heading,
    subheading,
    category,
    component: 'header',
    event_category,
    event_action,
    event_label
  }

  window.utag.link(payload)

  return `Tealium event sent: ${event_category} - ${event_action} - ${event_label}`
}
